import {Component, OnInit, Input, Output, EventEmitter, Renderer2, ViewChild, ElementRef, HostListener} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {TasksService} from '../../../tasks/tasks.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../../services/events.service';
import {NavService} from '../../../../services/nav.service';
import {UserService} from '../../../../services/user.service';
import {AlertController} from '@ionic/angular';

@Component({
  selector: 'app-journey-list-template-ai-coach',
  templateUrl: './list-template-ai-coach.component.html',
  styleUrls: ['./list-template-ai-coach.component.scss']
})
export class LearningJourneyListTemplateAICoachComponent implements OnInit {

  subscriptions: Subscription[] = [];

  task: TasksModel = null;

  @Input() disabled = false;

  @Input('task') set setDetails(task) {
    if (!!task) {
      this.task = task;
      this.checkBrowser();
    }
  }

  constructor(
    private tasksService: TasksService,
    public sanitizer: DomSanitizer,
    private event: EventsService,
    private renderer: Renderer2,
    private nav: NavService,
    public userService: UserService,
    private alertController: AlertController,
  ) {
  }

  ngOnInit() {
  }

  checkBrowser() {
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const isEdge = /Edge/.test(navigator.userAgent) && /Edg/.test(navigator.vendor);
    console.log('isChrome', isChrome);
    console.log('isEdge', isEdge);

    if (!isChrome && !isEdge) {
      // this.showBrowserAlert();
    }
  }

  showBrowserAlert() {
    this.alertController.create({
      header: 'Recommendation',
      message: 'Please use Chrome or Edge to take the final exam',
      buttons: [{
        text: 'I understand',
        cssClass: 'alert-controller-warning',
      }]
    }).then(a => a.present());
  }

  goToAICoach(index) {
    if (this.disabled) {
      return;
    }

    this.nav.navigate(['/calls/aicoach', this.task.id, index + 1]);
  }
}
